import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ExxComError } from 'lib/classes/exxcom-error.class';

const scriptName = 'header.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() isResourcePage: boolean;
    isBrowser: boolean;

    isNarrow: boolean;
    menuActive: boolean;
    overlayVisible: boolean = false;
    overlayZindex: number = 100;
    searchActive: boolean;
    toggleSearch: boolean;

    private destroy$ = new Subject<void>();

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private breakpointObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    async ngOnInit() {
        try {
            this.initBreakpointObserver();
        } catch (err) {
            console.error(...new ExxComError(392887, scriptName, err).stamp());
        }
    }

    private initBreakpointObserver() {
        try {
            this.breakpointObserver
                .observe(['only screen and (min-width: 1100px)'])
                .pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                    this.isNarrow = !result.matches;
                    /**
                     * Everything closes when the breakpoint changes. The overlay is
                     * controlled in this component. Closing the individual menus is
                     * controlled in the child components.
                     */
                    this.overlayVisible = false;
                    this.menuActive = false;
                    this.searchActive = false;
                    this.cdr.markForCheck(); // Trigger change detection with OnPush
                });
        } catch (err) {
            console.error(...new ExxComError(320948, scriptName, err).stamp());
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private setOverlayVisibility() {
        try {
            this.overlayVisible = this.menuActive || this.searchActive;
        } catch (err) {
            console.error(...new ExxComError(103887, scriptName, err).stamp());
        }
    }

    onActiveChange(which: string, $event: boolean, zIndex: number) {
        try {
            this[`${which}Active`] = $event;
            this.overlayZindex = zIndex;
            this.setOverlayVisibility();
        } catch (err) {
            console.error(...new ExxComError(620958, scriptName, err).stamp());
        }
    }

    onToggleSearch($event: boolean) {
        try {
            this.toggleSearch = $event;
        } catch (err) {
            console.error(...new ExxComError(997773, scriptName, err).stamp());
        }
    }
}
